// Canonical Machinery Norms upload-template columns (used by the sample
// template download in MachineryNormUploadModal).
//
// THREE sync points — any header change must stay in sync across all of them:
//   1. The backend parser (prx_project_management_service — the
//      machinery-norms equivalent of parseManpowerNormsFileToJson) locates the
//      header row by the 'Norm Code' cell and maps columns BY HEADER TEXT.
//   2. The backend master EXPORT helper builds the xlsx in this same format
//      (machinery-norms export helper).
//   3. This template (headers + widths + sample rows).
//
// Machinery is FLAT — every row is a standalone rate (unique key = Activity
// Name + Norm Code + Description), there is NO forward-fill.
//
// NOTE on 'Activity Name': include the activity code in parentheses, e.g.
// "ADIT-3A EXCAVATION(AE-0102)" — the backend matches the text against the
// project's activities and the code suffix makes that match reliable. At org
// scope (projectId 0) the text is stored as-is with no activity link.

export const MACHINERY_TEMPLATE_HEADERS = [
  "Activity Name",
  "Norm Code",
  "Description",
  "Nearest Dump",
  "Total Lead",
  "UOM",
  "Rate",
];

export const MACHINERY_TEMPLATE_COL_WIDTHS = [
  { wch: 36 },
  { wch: 12 },
  { wch: 50 },
  { wch: 18 },
  { wch: 12 },
  { wch: 10 },
  { wch: 12 },
];

// Real Mucking rows (rate depends on Activity + Norm Code).
export const MACHINERY_TEMPLATE_SAMPLE_ROWS: (string | number)[][] = [
  [
    "ADIT-3A EXCAVATION(AE-0102)",
    "B3.1.1",
    "Class III",
    "Hiller Peernia",
    2.50038,
    "Cum",
    219,
  ],
  [
    "ADIT-3A EXCAVATION(AE-0102)",
    "B3.1.2",
    "Class IV",
    "Hiller Peernia",
    2.50038,
    "Cum",
    219,
  ],
  [
    "ADIT-3A EXCAVATION(AE-0102)",
    "B3.9",
    "Removal of material arising from overbreak accepted due to geological conditions.",
    "Hiller Peernia",
    2.50038,
    "Cum",
    219,
  ],
];
